




























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import { HsabExpenseResponse } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import HsabExpenseCardRowExpanded from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpanded.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill,
    HsabExpenseCardRowExpanded,
    HsabExpenseForm,
    GenericLoadingSpinner,
  }
})
export default class HsabExpenseDetailsModal extends Vue {
  themeStore = useThemeStore();
  @Prop()
  expense: HsabExpenseResponse;

  @Prop()
  showModal: boolean;

  handleOnEditClose () {
    this.$emit("handle-close");
  }

}
